'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.FeatureToggle'];
module.exports = angular.module('AVRO.RomSummary.Filters', dependencies).controller('romSummaryFiltersController', require('./controllers/RomSummaryFiltersController')).directive('rmRomSummaryFilters', require('./directives/RomSummaryFiltersDirective'));